import DonLinear from "@/assets/icons/don-filled-linear.svg?react";
import IconQrCode from "@/assets/icons/qr-code.svg?react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import { formatNumber } from "@/shared/utils";
import { useTranslation } from "react-i18next";

interface LoyaltyCardProps {
  holderName: string;
  donBalance: string;
  tier: string;
  onShowQR: () => void;
}

export default function LoyaltyCard({
  holderName,
  donBalance,
  onShowQR,
}: LoyaltyCardProps) {
  const { t } = useTranslation();
  const balance = parseFloat(donBalance || "0");

  return (
    <div className="bg-white/10 p-px rounded-lg">
      <div className="bg-gray-4 p-3 rounded-lg relative overflow-hidden">
        {/* Pattern overlay */}
        <img
          className="w-[161px] h-auto absolute right-0 top-0 z-0 opacity-60"
          src="images/patterns/challenge-info.webp"
          alt=""
        />

        <div className="relative z-10">
          {/* Top: DON Card + Show QR */}
          <div className="flex items-center justify-between">
            <div className="flex items-center rounded-full gap-2.5">
              <div className="flex-center rounded-full">
                <DonLinear
                  className="size-[36px]"
                />
              </div>
              <div>
                <p className="text-base leading-130 text-white font-bold">
                  DON Card
                </p>

              </div>
            </div>
            <VibratingButton
              onClick={onShowQR}
              className="flex-y-center gap-1.5 bg-white/10 backdrop-blur-[10px] rounded-lg px-3 py-2 transition-200 active:bg-white/12"
              vibrationType="light"
            >
              <IconQrCode className="size-4 text-orange-100" />
              <span className="text-xs font-bold text-orange-100 leading-130">
                {t("show_qr")}
              </span>
            </VibratingButton>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-white/08 my-3" />

          {/* Bottom: holder + balance */}
          <div className="flex-center-between">
            <div>
              <p className="text-xs font-normal leading-130 text-gray-1 mb-0.5">
                {t("card_holder")}
              </p>
              <p className="text-sm text-white font-medium leading-130">
                {holderName}
              </p>
            </div>
            <div className="text-right">
              <p className="text-xs font-normal leading-130 text-gray-1 mb-0.5">
                {t("balance")}
              </p>
              <div className="flex items-center gap-1.5">
                <DonLinear className="size-5" />
                <p className="font-bold text-xl bg-yellow-linear text-transparent bg-clip-text leading-130">
                  {formatNumber(balance)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
